export default __webpack_public_path__ + "static/media/bg-2.79b408da.jpg";